import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  CreateTaskMutation,
  CreateTaskMutationVariables,
  CreateTaskDocument,
  FetchTasksByTenderIdDocument,
} from "@/graphql/__generated__/graphql";

export default function useCreateTaskMutationHook(): {
  createTaskMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [createTaskMutation, { loading, error }] = useMutation<CreateTaskMutation, CreateTaskMutationVariables>(
    CreateTaskDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "task-created-success",
          data: {
            title: t("toasts.taskcreated"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: FetchTasksByTenderIdDocument,
          variables: { tenderId: Number(tenderID) },
        },
      ],
    });

  return {
    createTaskMutation,
    loading,
    error,
  };
}
